export const isEmptyTag = (value = '') => value.trim().length === 0;
